export { SignificationTable } from './significationTable/significationTable'
